/**
 * Demo Booking Types
 *
 * Shared types for the /demo booking page and API routes.
 * No database — Google Calendar event IS the record of truth.
 */

// =============================================================================
// TIME SLOTS
// =============================================================================

export interface TimeSlot {
  /** UTC ISO string for slot start */
  startUtc: string;
  /** UTC ISO string for slot end */
  endUtc: string;
  /** Display string in owner timezone, e.g. "10:00 - 11:00" */
  display: string;
  /** Hour in owner timezone (0-23) for sorting */
  hour: number;
  /** Whether this slot is already booked */
  booked?: boolean;
}

// =============================================================================
// BOOKING FORM
// =============================================================================

export interface DemoBookingForm {
  name: string;
  email: string;
  phone: string;
  company: string;
  teamSize: string;
}

export const TEAM_SIZES = [
  { value: "1-5", label: "1-5 people" },
  { value: "6-20", label: "6-20 people" },
  { value: "21-50", label: "21-50 people" },
  { value: "51-200", label: "51-200 people" },
  { value: "200+", label: "200+ people" },
] as const;

// =============================================================================
// API RESPONSES
// =============================================================================

export interface AvailableSlotsResponse {
  success: boolean;
  slots: TimeSlot[];
  timezone: string;
  date: string;
}

export interface BookingResponse {
  success: boolean;
  meetLink?: string;
  eventId?: string;
  dateTime?: string;
  error?: string;
}

export interface BookingErrorResponse {
  success: false;
  error: string;
  code?: "SLOT_TAKEN" | "VALIDATION_ERROR" | "CALENDAR_ERROR" | "RATE_LIMITED";
}
